// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_file_qa.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { ListProposalFileQARequest, ListProposalFileQAResponse, RunProposalFileQARequest, RunProposalFileQAResponse, SelectProposalFinalFileRequest, SelectProposalFinalFileResponse } from "./proposal_file_qa_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * QA-only final-file selection; this is not a submission ledger. Tenant and actor
 * are principal-derived. All methods require a Proposal owner/manager or an
 * assigned outline writer/reviewer who is a member of that Proposal.
 *
 * @generated from service mono.projectdata.v1.ProposalFileQAService
 */ export const ProposalFileQAService = {
    typeName: "mono.projectdata.v1.ProposalFileQAService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.ProposalFileQAService.SelectProposalFinalFile
     */ selectProposalFinalFile: {
            name: "SelectProposalFinalFile",
            I: SelectProposalFinalFileRequest,
            O: SelectProposalFinalFileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProposalFileQAService.RunProposalFileQA
     */ runProposalFileQA: {
            name: "RunProposalFileQA",
            I: RunProposalFileQARequest,
            O: RunProposalFileQAResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProposalFileQAService.ListProposalFileQA
     */ listProposalFileQA: {
            name: "ListProposalFileQA",
            I: ListProposalFileQARequest,
            O: ListProposalFileQAResponse,
            kind: MethodKind.Unary
        }
    }
};
